import SentryErrorBoundaryFallback from './SentryErrorBoundaryFallback.component';

export default SentryErrorBoundaryFallback;
